export default {
	enoc_request: {
		en: "eNOC Request",
		ar: "طلب شهادة عدم ممانعة إلكترونية",
	},
	owners_association: {
		en: "Owners Association",
		ar: "جمعية الملاك",
	},
	please_confirm_cancel_request: {
		en: "Please confirm cancellation request",
		ar: "الرجاء تأكيد طلب الإلغاء",
	},
	eligibility_status: {
		en: "Eligibility Status",
		ar: "حالة الأهلي",
	},
	uae_resident: {
		en: "UAE Resident ?",
		ar: "مقيم في الإمارات؟",
	},
	ownership_type: {
		en: "Ownership Type",
		ar: "نوع الملكية",
	},
	buyer_delete_confirm: {
		en: "Please confirm to delete this buyer?",
		ar: "هل أنت متأكد من حذف بيانات هذا العميل ؟",
	},
	passport_issue_place: {
		en: "Passport Issue Place",
		ar: "بلد إصدار جواز السفر",
	},
	share_owned: {
		en: "Share Owned",
		ar: "حصة مملوكة",
	},
	share_value: {
		en: "Share Value",
		ar: "النسبة المملوكة",
	},
	property_size: {
		en: "Property Size",
		ar: "مساحة العقار",
	},
	property_size_eq_share_value: {
		en: "Please update share value. Total share should be equal to property total area.",
		ar: "يرجى تحديث قيمة السهم. يجب أن تكون الحصة الإجمالية مساوية لمساحة الملكية الإجمالية.",
	},
	please_enter_correct_share_value: {
		en: "Please enter correct share value",
		ar: "الرجاء إدخال قيمة الأسهم الصحيحة",
	},
	user_not_found_in_system: {
		en: "We were unable to locate your information based on your Emirates ID number.",
		ar: "لم نتمكن من تحديد معلوماتك بناءً على رقم هوية الإمارات",
	},
	incomplete_information_in_system: {
		en: "Your personal information is not updated in DLD. Please update by visiting one of the registration trustee office.",
		ar: "لا يتم تحديث معلوماتك الشخصية في دائرة الأراضي والأملاك في دبي. يرجى التحديث عن طريق زيارة مكتب أمين التسجيل",
	},
	non_residence_info: {
		en: "Please enter valid Emirates ID number or proceed with non-UAE resident option.",
		ar: "يرجى إدخال رقم هوية إماراتية صالح أو المتابعة مع خيار غير المقيمين في الإمارات",
	},
	total_area_size_enoc: {
		en: "Total Property Size: ",
		ar: "إجمالي حجم العقار",
	},
	total_size_eq_to_property_size: {
		en: "Total share value should be equal to total property size.",
		ar: "إجمالي القيمة المشتركة يجب ان تكون مساوية لإجمالي حجم العقار",
	},
	verify_eid: {
		en: "To proceed, Please verify emirates id.",
		ar: "للمتابعة, يرجى التحقق من بطاقة الهوية",
	},
	re_submit: {
		en: "Resubmit",
		ar: "إعادة تقديم الطلب",
	},
	property_info: {
		en: "Property Info",
		ar: "معلومات الممتلكات",
	},
	add_buyer: {
		en: "Add Buyer",
		ar: "أضف المشتري",
	},
	update_buyer: {
		en: "Update Buyer",
		ar: "تحديث المشتري",
	},
	english_name: {
		en: "Name (English)",
		ar: "الاسم (بالانجليزية)",
	},
	arabic_name: {
		en: "Name (Arabic)",
		ar: "الاسم (عربي)",
	},
	birth_place: {
		en: "Place of birth",
		ar: "مكان الميلاد",
	},
	jop_services: {
		en: "Mollak Services Gateway",
		ar: "بوابة خدمات الملاك",
	},
	enquiry: {
		en: "Enquiry and Request",
		ar: "استفسارات وطلبات",
	},
	suggestion: {
		en: "Suggestion",
		ar: "اقتراح",
	},
	complaints: {
		en: "Complaints",
		ar: "شكاوى",
	},
	legal: {
		en: "Rectification Notice",
		ar: "انذار تصويب الوضع",
	},
	enquiry_type: {
		en: "Enquiry Type",
		ar: "نوع التساؤل",
	},
	suggestion_type: {
		en: "Suggestion Type",
		ar: "نوع الاقتراح",
	},
	complaints_type: {
		en: "Complaint Type",
		ar: "نوع الشكوى",
	},
	category_type: {
		en: "Category Type",
		ar: "نوع التصنيف",
	},
	legal_request_list: {
		en: "Rectification Request List",
		ar: "كشف طلبات تصويب الوضع",
	},
	attached_documents: {
		en: "Attached Documents",
		ar: "المرفقات",
	},
	add_one_entry: {
		en: "Please add at least one (1) entry",
		ar: "يرجى إدخال طلب واحد (1) على الأقل",
	},
	legal_requests: {
		en: "Rectification Requests",
		ar: "طلبات تصويب الوضع",
	},
	complaint_requests: {
		en: "Complaint Requests",
		ar: "طلبات شكاوى",
	},
	suggestion_requests: {
		en: "Suggestion Requests",
		ar: "طلبات مقترحة",
	},
	enquiry_requests: {
		en: "Enquiry Requests",
		ar: "طلبات الاستفسار",
	},
	delete_entry_confirm: {
		en: "Are you sure you want to delete this entry?",
		ar: "هل أنت متأكد من حذف هذا الطلب؟",
	},
	request_submitted: {
		en: "Request Submitted Successfully",
		ar: "تم تقديم الطلب بنجاح",
	},
	request_submitted_detail: {
		en: "Your request has been submitted successfully",
		ar: "تم تقديم طلبك بنجاح",
	},
	management_company_status: {
		en: "Management Company Status",
		ar: "حالة شركة الإدارة",
	},
	owner_status: {
		en: "Owner Status",
		ar: "حالة المالك",
	},
	requester_status: {
		en: "Requester Status",
		ar: "حالة مقدم الطلب",
	},
	close_request: {
		en: "Close Request",
		ar: "إغلاق الطلب",
	},
	transfer_to_rera: {
		en: "Transfer to RERA",
		ar: "تحويل الى مؤسسة التنظيم العقاري",
	},
	forward_to_oc: {
		en: "Forward to Owner Committee",
		ar: "إحال إلى لجنة المالك",
	},
	request_tender: {
		en: "Request Tender",
		ar: "طلب مناقصة",
	},
	jop_note: {
		en: "In order to advance the case against the Management Company to RERA, it is necessary to provide feedback (approval or rejection) on each task submitted to the Management Company.",
		ar: "من أجل رفع شكوى ضد شركة الإدارة إلى مؤسسة التنظيم العقاري، من الضروري تقديم الملاحظات (الموافقة أو الرفض) على كل مهمة تم تقديمها إلى شركة الإدارة.",
	},
	details: {
		en: "Details",
		ar: "التفاصيل",
	},
	owner_feedback: {
		en: "Owner Comments",
		ar: "ملاحظات المالك",
	},
	requester_feedback: {
		en: "Requester Comments",
		ar: "تعليقات مقدم الطلب",
	},
	company_feedback: {
		en: "Company Comments",
		ar: "ملاحظات الشركة",
	},
	status_from_owner: {
		en: "Status From Owner",
		ar: "الحالة من المالك",
	},
	status_from_requester: {
		en: "Status From Requester",
		ar: "الحالة من مقدم الطلب",
	},
	confirm_close_request: {
		en: "Are you sure you want to close this request?",
		ar: "هل أنت متأكد أنك تريد إغلاق هذا الطلب؟",
	},
	confirm_forward_to_oc: {
		en: "Are you sure you want to forward this request to Owner Committee?",
		ar: "هل أنت متأكد أنك تريد إعادة توجيه هذا الطلب إلى لجنة المالك؟",
	},
	enquiry_details: {
		en: "Enquiry Details",
		ar: "تفاصيل الاستفسار",
	},
	suggestion_details: {
		en: "Suggestion Details",
		ar: "تفاصيل الاقتراح",
	},
	complaint_details: {
		en: "Complaint Details",
		ar: "تفاصيل شكوى",
	},
	legal_request_details: {
		en: "Rectification Notice Details",
		ar: "تفاصيل انذار تصويب الوضع",
	},
	transfer_reason: {
		en: "Transfer Reason",
		ar: "سبب التحويل",
	},
	technical: {
		en: "Technical",
		ar: "فني",
	},
	financial: {
		en: "Financial",
		ar: "مالي",
	},
	owner_committee_meeting_date: {
		en: "Owner Committee Meeting Date",
		ar: "تاريخ اجتماع لجنة الملاك",
	},
};
